import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

const PATHS_TO_HIDE_COMMENTS = [
  ROUTE_PATH.LINKS
]

export default function shouldHideCommentsRouteUtil (path) {
  return PATHS_TO_HIDE_COMMENTS.includes(path)
}
